import React from 'react';
type FilterChipsProps<T extends string> = {
  options: T[];
  value: T;
  onChange: (value: T) => void;
  ariaLabel?: string;
};
export function FilterChips<T extends string>({
  options,
  value,
  onChange,
  ariaLabel = 'Filter updates by product'
}: FilterChipsProps<T>) {
  return <div role="group" aria-label={ariaLabel} className="-mx-6 flex gap-2 overflow-x-auto px-6 pb-1 [scrollbar-width:none] md:mx-0 md:flex-wrap md:justify-center md:overflow-visible md:px-0 [&::-webkit-scrollbar]:hidden" data-id="element-1695" data-mp="10n6kkyl9gv8a">
      {options.map(option => {
      const active = option === value;
      return <button key={option} type="button" aria-pressed={active} onClick={() => onChange(option)} className={`h-10 shrink-0 whitespace-nowrap rounded-full border px-4 text-[14px] font-medium transition-colors duration-150 ease-out ${active ? 'border-ink bg-ink text-white' : 'border-canvas-line bg-white text-ink hover:border-ink/30'}`} data-id="element-1696" data-mp="1fdm3u7u49t3t">
            {option}
          </button>;
    })}
    </div>;
}